import { matchPath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

const APP_ORIGIN_ROUTES = {
  appTemplate: [ROUTES.appTemplate],
  assistant: [
    ROUTES.assistantUI,
    '/guide/*'
  ],
  banking: [
    ROUTES.bankingUI,
    ROUTES.bankOfAmericaOffer
  ],
  business: [
    ROUTES.businessOverview,
    ROUTES.businessProfile,
    ROUTES.subscriptions,
    ROUTES.orders
  ],
  compliance: [
    ROUTES.amendments,
    ROUTES.annualReports,
    ROUTES.beneficialOwnership,
    ROUTES.meetingMinutes,
    ROUTES.complianceOverview
  ],
  documents: [
    ROUTES.businessDocuments,
    ROUTES.documentTemplates
  ],
  ecommServices: [ROUTES.ecommServicesUI],
  education: [ROUTES.education],
  invoicing: [ROUTES.invoicingUI],
  money: [
    ROUTES.entityMoney,
    ROUTES.taxServices,
    ROUTES.entityFinanceHub,
    ROUTES.entityFinanceHubLinkedAccounts
  ],
  websites: [ROUTES.marketingTools],
  zendash: [
    ROUTES.callback,
    ROUTES.login,
    ROUTES.logout
  ]
};

const APP_ORIGIN_ROUTE_UI = {
  appTemplate: 'app-template-ui',
  assistant: 'assistant-ui',
  banking: 'banking-ui',
  business: 'business-operations-ui',
  compliance: 'compliance-ui',
  documents: 'documents-ui',
  ecommServices: 'ecomm-services-ui',
  education: 'education-ui',
  invoicing: 'invoicing-ui',
  journeys: 'journeys-ui',
  money: 'money-ui',
  websites: 'websites-ui',
  zendash: 'zendash'
};

export function getAppOrigin(pathname) {
  for (const [origin, routes] of Object.entries(APP_ORIGIN_ROUTES)) {
    if (routes.some((route) => matchPath(route, pathname))) {
      return APP_ORIGIN_ROUTE_UI[origin] || 'dashboard-ui';
    }
  }
  return 'dashboard-ui';
}
